export const progressCareerQuery = `query progressCareerQuery($uid: Int!, $subscriptionMemberId: Int!, $workspaceId: Int!) {
  SubscriptionMember{
    item(subscriptionMemberId: $subscriptionMemberId){
      user {
          careers(active: true, workspaceId: $workspaceId) {
            id
            name
          	progress(uid: $uid)
          }
        }
    }
  }
}`;
